import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Product } from '@shared/models/product.model';

@Component({
  selector: 'app-home-page',
  templateUrl: './home-page.component.html',
  styleUrls: ['./home-page.component.scss']
})
export class HomePageComponent implements OnInit {
  showcases: Product[] = [];

  constructor(private route: ActivatedRoute) {}

  ngOnInit(): void {
    this.route.data.subscribe((data: { showcase: any }) => {
      this.showcases = data.showcase?.content ?? [];
      this.showcases.sort((a, b) => this.sortByDisplayOrder(a, b));
    });
  }

  private sortByDisplayOrder(a: Product, b: Product): number {
    const aDisplay = (a.productSkus[0].productSkuEavs.find(e => e.attribute === 'displayorder') || {} as any).value;
    const bDisplay = (b.productSkus[0].productSkuEavs.find(e => e.attribute === 'displayorder') || {} as any).value;
    const orderA = isNaN(parseInt(aDisplay)) ? 1 : parseInt(aDisplay);
    const orderB = isNaN(parseInt(bDisplay)) ? 1 : parseInt(bDisplay);
    return orderB - orderA;
  }
}
